import { i18n } from "discourse-i18n";
import ValidationTip from "./validation-tip";

const FormFieldWireFrame = <template>
  <div class="field {{@fieldName}}">
    <label class="control-label {{if @required 'required'}}" for={{@fieldName}}>
      {{#if @title}}
        <span>
          <span>{{@title}}</span>
          {{#if @required}}
            <span class="required_flag">
              {{i18n "discourse_circles.form.required_field_indicator"}}
            </span>
          {{/if}}
        </span>
      {{/if}}
      {{#if @description}}
        <span class="control-label__info">
          {{@description}}
          {{#unless @title}}
            {{#if @required}}
              <span class="required_flag">
                {{i18n "discourse_circles.form.required_field_indicator"}}
              </span>
            {{/if}}
          {{/unless}}
        </span>
      {{/if}}
    </label>
    {{yield}}
    <ValidationTip
      @validation={{@validation}}
      @value={{@value}}
      @maxLength={{@maxLength}}
    />
  </div>
</template>;

export default FormFieldWireFrame;
